/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
export const environment = {
  production: true,
  onprem: false,
  name: "test",
  deployment: 'saglık.aed',
  preloaderDisplayed:true,
  version: require('../../package.json').version,
  assets: {
    kpiEditorDocumentationUrl: 'https://assets.geleceginsehri.com/documents/KPIEditorDocumentation.docx',
    preloaderVideoUrl: 'https://assets.geleceginsehri.com/${REALM_ID}/uruk_preload_1920x1080.mp4',
    preloaderVideoVideowallUrl: 'https://assets.geleceginsehri.com/documents/uruk_preload_5760x2160.mp4',
  },
  auth: {
    enabled: true,
    admin_url: 'https://aed.kalplerikazan.com/auth/admin/realms/${REALM_ID}',
    base_url: 'https://aed.kalplerikazan.com/auth/realms/${REALM_ID}/protocol/openid-connect',
    authorization_endpoint: 'auth',
    token_endpoint: 'token',
    logout_endpoint: 'logout',
    redirect_endpoint: 'onauthresult', // this should not have a leading '/'
    clientId: 'uruk-ui', // client id to retrieve an access token
    uma_token_audience: 'uruk-platform', // audience to retrieve UMA token
    master_realm_id: '*', // the identifier of master realm
    response_type: 'id_token token',
    scope: 'openid profile'
  },
  defaultLanguage: 'tr',
  map: { // settings to manage menu configuration
    framework: 'Maplibre', // could be Leaflet, Maplibre or Maprays
    tileType: 'Default', // could be Default, Satellite, RoadMap
    bounds: [23.894, 33.346, 47.935, 44.381],
    defaultZoom: 10,
    leaflet: {
      tileUrl: 'https://tile.googleapis.com/v1/2dtiles/{z}/{x}/{y}?',
      tileUrlRoadMap: '',
      tileUrlSatellite: '',
      center: {
        lat: 39.8997115,
        lng: 32.829017
      },
      defaultZoom: 11,
      maxZoom: 22,
      minZoom: 5
    },
    maplibre: {
      styleUrl: 'https://maptest.geleceginsehri.com/styles/dark-matter/style.json',
      center: {
        lat: 39.8997115,
        lng: 32.829017
      },
      defaultZoom: 10,
      maxZoom: 18,
      minZoom: 0,
    },
    maprays: {
      tileUrl: 'https://maptest.geleceginsehri.com/styles/dark-matter/{z}/{x}/{y}.png',
      mapBounds: {
        southwest: {
          latitude: 34.930859295248695,
          longitude: 24.218022341271876
        },
        northeast: {
          latitude: 42.82061342649127,
          longitude: 45.88108801052261
        }
      },
      maxLevel: 18
    }
  },
  retryCount: { // how many times to retry an action such as API call
    fetchAlert: 3
  },
  routes: { // settings to manage dynamic routes
    alerts: 'alerts',
    analytics: 'analytics',
    platform: {
      userManagement: 'user-management',
      kpis: 'kpis',
      platform: 'platform',
      regions: 'regions',
      realms: 'realms',
      layers: 'layers',
      pages: 'pages',
      pageTemplates: 'page-templates',
      subdomains: 'subdomains',
      structureDefinitions: 'structure-definitions',
      contextSources: 'context-sources',
      trafficManagementSimulator: 'trafficManagementSimulator',
      patterns: 'patterns',
      deviceManagement: 'device-management'
    },
    pages: 'pages',
    reports: 'reports',
    workflow: 'workflow'
  },
  server: { // settings to access for the backend
    adminApi: 'https://aed.kalplerikazan.com/admin',
    analyticsApi: 'https://aed.kalplerikazan.com/analytics',
    contextBrokerApi: 'https://aed.kalplerikazan.com/cbroker',
    ingestionApi: 'https://aed.kalplerikazan.com/ingestion',
    predictionApi: 'https://aed.kalplerikazan.com/predict',
    cepApi: 'https://aed.kalplerikazan.com/cep',
    deviceManagementApi: 'https://aed.kalplerikazan.com/device'
  },
  subscriptions: { // settings for websocket communication
    enabled: true,
    endpoint: 'wss://aed.kalplerikazan.com/uruk-wss'
  },
  timeouts: {
    debounceTimes: { // settings of delays for the event subscriptions (in ms)
      geologicalQueries: 500,
      searchQueries: 500,
      mapLayoutChange: 350
    },
    fetchAlert: 3000, // timeout to fetch alert (in ms)
    mouseIdleTimeout: 5000 // timeout to consider mouse idle (in ms)
  },
  workflow: {
    url: 'https://wf.aedkalplerikazan.com/',
    managementRoute: '/api/nodered'
  }
};
